import { IModalStore } from '../index'
import { ICloseModal } from '../../../actions/Modals/closeModal'

const closeModal = (store: IModalStore, action: ICloseModal): IModalStore => ({
  ...store,
  tooltips: [],
  modals: store.modals.filter(
    modal =>
      !(action.uid
        ? modal.id.includes(action.uid)
        : modal.id.includes(action.id)),
  ),
})

export default closeModal
